import Cookies from "universal-cookie";
import axios from "axios";
import { JWT_COOKIE_NAME, AUTH_REDIRECT } from "../constants";
// import {fetchUser} from 'store/actions/user'
import { format } from "date-fns";
import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// export async function withUserAuth(ctx){
//     const {req, res} = ctx
//     setHeaderCookie(req)
//     const reduxStore = initializeStore()
//     await  reduxStore.dispatch(fetchUser())
//     const state = reduxStore.getState()
//     if(state && !state.userData.user){
//         return {
//           redirect: {
//             destination: '/cms/login/',
//             permanent: false,
//           },
//         }
//       }
//     else if(state && state.userData.user && (!state.userData.user?.data?.is_staff)){
//       return {
//           redirect: {
//             destination: '/',
//             permanent: false,
//           }
//       }
//     }
//     return {
//         props: {
//             _user: state && state.userData && state.userData.user
//         }
//     }
// }

export const setHeaderCookie = (req) => {
  const cookies = new Cookies(req.headers.cookie);
  if (cookies.get(JWT_COOKIE_NAME + "_access")) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${cookies.get(
      JWT_COOKIE_NAME + "_access"
    )}`;
  } else {
    axios.defaults.headers.common["Authorization"] = null;
  }
};

export const gaEvent = (event, category, action, label) => {
  if (window !== undefined) {
    window?.gtag(event, {
      event_category: category,
      event_label: label,
      event_action: action,
    });
  }
};

export const gaDataLayer = (
  contentType,
  pageType,
  domainId,
  entityID,
  authorUid,
  authorName,
  entityCreated,
  entityUpdated,
  userLoginStatus,
  userUid,
  microsite,
  entityLanguage,
  preferredEducationLevel,
  side_article
) => {
  if (window !== undefined && window?.dataLayer !== undefined) {
    window?.dataLayer?.push({
      contentType,
      pageType,
      domainId,
      entityID,
      authorUid,
      authorName,
      entityCreated,
      entityUpdated,
      userLoginStatus,
      userUid,
      microsite,
      entityLanguage,
      preferredEducationLevel,
      side_article,
    });
  }
};

export const dateTimeExtractor = (date, type = "date-time") => {
  const newDate = new Date(date);
  if (type === "date") {
    return format(newDate, "d MMM''yy");
  }
  if (type === "time") {
    return format(newDate, "hh:mm a");
  }
  if (type === "date-time") {
    return format(newDate, "d MMM''yy, hh:mm a");
  }
};

export const validateImage = (obj, x, y) => {
  const maxWidth = x;
  const maxHeight = y;
  var reader = new FileReader();
  reader.readAsDataURL(obj);
  reader.onload = function (e) {
    var image = new Image();
    image.src = e.target.result;
    image.onload = function () {
      var height = this.height;
      var width = this.width;
      if (height > maxHeight || width > maxWidth) {
        return false;
      }
      return true;
    };
  };
};

export const sameDateChecker = (start_date, end_date) => {
  if (end_date === null) {
    return dateTimeExtractor(start_date);
  }
  if (start_date === null) {
    return dateTimeExtractor(end_date);
  }
  let startDate = start_date && dateTimeExtractor(start_date, "date");
  let endDate = end_date && dateTimeExtractor(end_date, "date");
  if (startDate === endDate) {
    return (
      dateTimeExtractor(start_date) +
      " - " +
      dateTimeExtractor(end_date, "time")
    );
  }
  if (end_date === undefined) {
    return dateTimeExtractor(start_date);
  }
  return dateTimeExtractor(start_date) + " - " + dateTimeExtractor(end_date);
};

export const spanHeadingFormatter = (string) => {
  if (string === null) {
    return undefined;
  }
  if (string === "") {
    return undefined;
  }
  let str = string.split(" ");
  if (str.length == 1) {
    return string;
  }
  let half = Math.ceil(str.length / 2);
  let firstHalf = str.splice(0, half);
  let secondHalf = str.splice(-half);
  firstHalf = firstHalf?.length > 1 ? firstHalf.join() : firstHalf[0];
  secondHalf =
    secondHalf && secondHalf.length > 1 ? secondHalf.join() : secondHalf[0];
  firstHalf = firstHalf?.length > 1 ? firstHalf?.replace(/,/g, " ") : firstHalf;
  secondHalf =
    secondHalf?.length > 1 ? secondHalf?.replace(/,/g, " ") : secondHalf;
  return (
    <>
      {firstHalf}{" "}
      {secondHalf && (
        <span className="popular_stories_heading_span">{secondHalf}</span>
      )}
    </>
  );
};

export const findMultipleStartLocationsOfElement = (data, element) => {
  let postionsArray = [];
  let postion = 0;
  let wholeData = data;
  let postionFromStart = 0;
  while (postion != "-1") {
    postion = wholeData.indexOf(element);
    if (postion != "-1") {
      postionFromStart = postionFromStart + postion + 1;
      postionsArray.push(postionFromStart - 1);
      wholeData = wholeData.slice(postion + 1);
    }
  }
  return postionsArray;
  //return array of positions
};

export const findMultipleEndLocationsOfElement = (data, element) => {
  let postionsArray = [];
  let postion = 0;
  let wholeData = data;
  let postionFromStart = 0;
  while (postion != "-1") {
    postion = wholeData.indexOf(element);
    if (postion != "-1") {
      postionFromStart = postionFromStart + postion + 1;
      postionsArray.push(postionFromStart + 1 + element.length - 1);
      wholeData = wholeData.slice(postion + 1);
    }
  }
  return postionsArray;
  //return array of positions
};

export const stringToParam = (data) => {
  let query = {};
  let source = data?.split("/")[data?.split("/")?.length - 1]?.split("&");
  for (let param of source) {
    let paramArray = param.split("=");
    if (paramArray[1] !== null && paramArray[1] !== undefined) {
      query[`${paramArray[0]}`] = paramArray[1];
    }
  }
  return query;
};

export const paramsFromObject = (params, query) => {
  Object.keys(query)?.forEach((key) => {
    if (key !== "ici" && key !== "icn") {
      if (query[key] != "") {
        params[key] =
          params[key] != undefined
            ? params[key] + "," + query[key]
            : query[key];
      }
    }
  });
  return params;
};

export const ordinalSuffixOf = (i) => {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return "st";
  }
  if (j == 2 && k != 12) {
    return "nd";
  }
  if (j == 3 && k != 13) {
    return "rd";
  }

  return "th";
};

export let numDifferentiation = (val) => {
  if (val >= 10000000) {
    val = (val / 10000000)?.toFixed(1) + " Cr";
  } else if (val >= 100000) {
    val = (val / 100000)?.toFixed(1) + " L";
  } else if (val >= 1000) val = (val / 1000)?.toFixed(1) + " K";
  else if (val % 1 != 0) val = val?.toFixed(1);
  return val;
};

export const moneyFormate = (val) => {
  if (0 < val && val < 1000) {
    return val + " Rupees";
  } else if (1000 <= val && val < 100000) {
    let formate = val % 1000 === 0 
        ? val / 1000 + " k" 
        : (val / 1000).toFixed(2) + " k";
    return formate;
  } else if (val >= 100000) {
    let formate = val % 100000 === 0
        ? val / 100000 + " Lakhs"
        : (val / 100000).toFixed(2) + " Lakhs";
    return formate;
  }
};

export const ImageTooltip = ({ href }) => { 
  return (
    <OverlayTrigger
      placement="right"
      overlay={
        <Tooltip id="image-tooltip">
          <div className="custom-tooltip">
            <img src={href} alt="Image" width="583px" height="283px" />
          </div>
        </Tooltip>
      }
    >
      <a href={href} target="_blank">
        {href}
      </a>
    </OverlayTrigger>
  );
};

// format date as 17 Jun 25, 03:30 PM
export const formatDate = (dateString) => {
  if(!dateString) return '';
  const newDate = new Date(dateString);
  const finalDate =
    format(newDate, "d MMM yy,") + " "+ format(newDate, "hh:mm a");
  return finalDate;
};

// format date as 17 Jun 2025
export const formatDateFor = (dateTimeString) => {
  const date = new Date(dateTimeString);

  // Get day
  const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits for day

  // Get month name
  const month = date.toLocaleString('default', { month: 'short' });

  // Get year
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

 // to extract error response of APIs
export const getDynamicMessage = (message) => {
  // Case 1: Message is a string (success or generic message)
  if (typeof message === 'string') {
    return message;
  }

  // Case 2: Message is an object (one or multiple field errors)
  if (typeof message === 'object' && message !== null) {
    // Join all messages into a single string (e.g. "keyword: ..., domain: ...")
    return Object.entries(message)
      .map(([field, msg]) => `${field}: ${msg}`)
      .join('\n');
  }

  // Fallback
  return 'Something went wrong';
};
// word counter
export const wordCounter = (text) => {
  if (!text || typeof text !== 'string') {
      return 0;
  }
  
  // Remove HTML tags if present
  const cleanText = text.replace(/<[^>]*>/g, '');
  
  // Split by whitespace and filter out empty strings
  const words = cleanText.trim().split(/\s+/).filter(word => word.length > 0);
  
  return words.length;
}
